var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    {
      attrs: {
        placeholder: _vm.placeholder,
        "filter-method": _vm.remoteMethod,
        size: _vm.size,
        loading: _vm.loading,
        disabled: _vm.disabled,
        filterable: "",
        clearable: "",
      },
      on: {
        "visible-change": _vm.visibleChange,
        change: _vm.change,
        clear: _vm.clear,
      },
      model: {
        value: _vm.model,
        callback: function ($$v) {
          _vm.model = $$v
        },
        expression: "model",
      },
    },
    _vm._l(_vm.associateData, function (item) {
      return _c("el-option", {
        key: item.value,
        attrs: { label: item.label, value: item.value },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }